// extracted by mini-css-extract-plugin
export default {"button":"JobSeekerDashboard_button__2xgBk"};